import { createFileRoute } from '@tanstack/react-router'
import { FinanceSection } from '~/components/marketing/finance-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { PricingEngineSection } from '~/components/marketing/pricing-engine-section'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'Os números — financeiro e hora técnica | Planno'
const PAGE_DESCRIPTION =
  'Custo da hora técnica calculado dos custos reais do escritório, fluxo de caixa, parcelas em série e DRE simplificado. A leitura financeira que o contador agradece.'

export const Route = createFileRoute('/recursos/numeros')({
  component: NumbersPage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'pt-BR',
      path: '/recursos/numeros',
      title: PAGE_TITLE,
    }),
})

function NumbersPage() {
  return (
    <MarketingShell>
      <PricingEngineSection headingLevel="h1" />
      <FinanceSection />
    </MarketingShell>
  )
}
